export default "__VITE_ASSET__D$x9UzFY__"